import script from "./WSendToBot.vue?vue&type=script&setup=true&lang=ts"
export * from "./WSendToBot.vue?vue&type=script&setup=true&lang=ts"

import "./WSendToBot.vue?vue&type=style&index=0&id=02ed40a7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ed40a7"]])

export default __exports__